import { render, staticRenderFns } from "./ItemGroupListView.vue?vue&type=template&id=7e8143bc"
import script from "./ItemGroupListView.vue?vue&type=script&lang=js"
export * from "./ItemGroupListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports